import {useState, useCallback} from "react";
import {useDispatch} from "react-redux";
import {useDisclosure} from "../../../hooks/useDisclosure";
import {deleteGroupData} from "../../../redux/Actions/group.action";

export const useGroupTableActions = (fetchAfterDelete) => {
  const {
    isOpen: isEditModalOpen,
    onOpen: openEditModal,
    onClose: closeEditModal,
  } = useDisclosure();
  const {
    isOpen: isDeleteModalOpen,
    onOpen: openDeleteModal,
    onClose: closeDeleteModal,
  } = useDisclosure();
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState(null);

  const clearSelectedRow = () => {
    setSelectedRow(null);
  };

  const handleActionSelection = useCallback(
    (action, data) => {
      setSelectedRow({
        ...data,
        permissions: data.permissions.map((item) => item.value),
        users: data.users.map((item) => item.value),
      });
      switch (action) {
        case "Edit":
          openEditModal();
          break;
        case "Delete":
          openDeleteModal();
          break;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleDelete = () => {
    const callback = () => {
      closeDeleteModal();
      clearSelectedRow();
      fetchAfterDelete();
    };
    dispatch(deleteGroupData(selectedRow?.id, callback));
  };

  const handleDeleteModalClose = () => {
    closeDeleteModal();
    clearSelectedRow();
  };

  const handleEditModalClose = () => {
    closeEditModal();
    clearSelectedRow();
  };

  return {
    closeDeleteModal: handleDeleteModalClose,
    closeEditModal: handleEditModalClose,
    handleActionSelection,
    handleDelete,
    isDeleteModalOpen,
    isEditModalOpen,
    selectedRow,
  };
};
